import ModuleNavbar from 'components/Navbars/ModuleNavbar'
import React, {useEffect, useState} from 'react'

// REACT STRAP COMPONENTS
import {
    Row,
    Col,
    Card,
    CardHeader,
    CardTitle,
    Button,
    CardBody,
    UncontrolledTooltip
} from 'reactstrap'
import {connect} from "react-redux";
import {clearEditErrors, editCompany, getMyCompany} from "../../../actions/companyActions";
import Spinner from "../../../components/common/Spinner";

const IndicatorsPage = (props) => {
    const {getMyCompany, loadingMy, errorMy, myCompany} = props
    const [func, setFunc] = useState(false);
    useEffect(() => {
        const asyncWrapper = async () => { await getMyCompany() }
        asyncWrapper()
    },[])

    const displayFunction = (e) => {
        setFunc(!func);
    }
    return (
        <div className="content">
            <ModuleNavbar title='Wskaźniki' icon='nc-icon nc-chart-bar-32' page={32}
                        //   gradient='linear-gradient(rgb(187, 255, 255) 0%, rgb(107, 188, 212) 70%) rgb(187, 255, 255)'
                          color='rgb(31, 99, 119)' func={displayFunction}/>

            {!func && <>
                {!loadingMy && Object.keys(myCompany).length > 0?
                props.children
                :
                    <Card>
                    <CardHeader>
                        <CardTitle className='text-center h4'>Ładowanie</CardTitle>
                    </CardHeader>
                    <CardBody>
                        <Row className='text-center'>
                            <Col className='ml-auto mr-auto'>
                                <Spinner/>
                            </Col>
                        </Row>
                    </CardBody>
                    </Card>
                }

            </>}
            {func && <>
                <Card>
                    <CardHeader>
                        <CardTitle tag="h5">
                            Drogi Użytkowniku,
                        </CardTitle>
                    </CardHeader>


                    <CardBody style={{textAlign: 'justify', lineHeight: '2', fontSize: '14px'}}>
                        W&nbsp;module wskaźników prezentowane są&nbsp;wartości podstawowych wskaźników ekonomiczno-finansowych i&nbsp;statystycznych 
                        na&nbsp;poziomie całego podmiotu oraz na&nbsp;poziomie wybranych ośrodków powstawania
                        kosztów. Moduł daje Ci możliwość zarówno przeglądania własnych wskaźników (zakładka Moje
                        wskaźniki), jak i&nbsp;bazując na&nbsp;zanonimizowanych danych porównywania ich wartości z&nbsp;innymi
                        podmiotami w&nbsp;całej Polsce i&nbsp;w&nbsp;poszczególnych województwach (zakładka Benchmarking). W&nbsp;zakładce
                        Twoje Sprawozdania Finansowe masz możliwość uzupełnienia danych z&nbsp;rocznego sprawozdania finansowego.
                        Aplikacja będzie rozbudowywana zgodnie z&nbsp;zapotrzebowaniem zgłaszanym przez użytkowników, wobec
                        czego zaproponowana w&nbsp;fazie początkowej baza wskaźników będzie sukcesywnie rozwijana.
                        Udostępnione aktualnie wskaźniki są&nbsp;skategoryzowane w&nbsp;następujących grupach:
                        <ul>
                            <li>wskaźniki ekonomiczno-finansowe  na&nbsp;poziomie całego podmiotu;
                            </li>
                            <li>wskaźniki ekonomiczno-finansowe na&nbsp;poziomie poszczególnych ośrodków kosztów;
                            </li>
                            <li>wskaźniki statystyczne.</li>
                            {/* <li>wskaźniki w&nbsp;zakresie analizy kosztów zasobów ludzkich.</li> */}
                        </ul>
                        W&nbsp;module wskaźników, w&nbsp;zakładce Moje wskaźniki wybierasz interesujący Cię wskaźnik i&nbsp;wskazujesz
                        zakres czasowy. Na&nbsp;tej podstawie generowany jest wykres obrazujący wartość Twojego wskaźnika
                        oraz medianę, wartość największą i&nbsp;najmniejszą <span id='comment'>(z&nbsp;wyłączeniem obserwacji odstających*) </span> 
                        danego wskaźnika dla&nbsp;podmiotów o&nbsp;podobnej kategorii i&nbsp;formie prawnej w&nbsp;Polsce. 
                        Z&nbsp;kolei w&nbsp;zakładce Benchmarking masz możliwość wyboru zakresu czasowego i&nbsp;województwa, 
                        a&nbsp;także kategorii i&nbsp;formy prawnej podmiotów, z&nbsp;którymi chciałbyś
                        porównać wartości swoich wskaźników. Wszystkie wykresy w&nbsp;module wskaźników możesz wyeksportować
                        do&nbsp;formatów svg, png i&nbsp;csv.
                        <UncontrolledTooltip delay={0} placement="top" target='comment' >
                            * obserwacja odstająca - obserwacja, która leży o&nbsp;co&nbsp;najmniej 1,5 IQR (IQR - rozstęp ćwiartkowy) powyżej trzeciego kwartyla, lub&nbsp;poniżej pierwszego kwartyla
                        </UncontrolledTooltip>
                        <br/><br/>

                        <span className='text-wskazniki text-bold'>Wskaźnik zyskowności netto </span>
                        <br/>
                        Wskaźnik zyskowności netto&nbsp;(%) wyznaczono w&nbsp;oparciu o&nbsp;Rozporządzenie&nbsp;MZ&nbsp;z&nbsp;dnia 12.04.2017&nbsp;roku. 
                        Wskaźnik pokazuje jaką część przychodów stanowi odnotowany zysk lub&nbsp;strata. W&nbsp;ten&nbsp;sposób jest określona efektywność gospodarki 
                        finansowej w&nbsp;odniesieniu do&nbsp;relacji przychody ogółem –&nbsp;koszty ogółem podmiotu. Zgodnie z&nbsp;punktacją zawartą 
                        w&nbsp;Rozporządzeniu za&nbsp;optymalny wynik wskaźnika uznaje&nbsp;się wartość powyżej&nbsp;4%. Bardzo wysokie wartości ujemne wskaźnika 
                        wskazują na&nbsp;trudności finansowe podmiotu.
                        <br/><br/>

                        <span className='text-wskazniki text-bold'>Wskaźnik zyskowności działalności operacyjnej </span>
                        <br/>
                        Wskaźnik zyskowności działalności operacyjnej&nbsp;(%) wyznaczono w&nbsp;oparciu o&nbsp;Rozporządzenie&nbsp;MZ&nbsp;z&nbsp;dnia 
                        12.04.2017&nbsp;roku. Wskaźnik określa ekonomiczną efektywność działania podmiotu, z&nbsp;uwzględnieniem działalności podstawowej 
                        oraz pozostałej działalności operacyjnej. Zgodnie z&nbsp;punktacją zawartą w&nbsp;Rozporządzeniu za&nbsp;optymalny wynik wskaźnika 
                        uznaje&nbsp;się wartość powyżej&nbsp;5%.
                        <br/><br/>

                        <span className='text-wskazniki text-bold'>Wskaźnik zyskowności aktywów</span>
                        <br/>
                        Wskaźnik zyskowności aktywów&nbsp;(%) wyznaczono w&nbsp;oparciu o&nbsp;Rozporządzenie MZ&nbsp;z&nbsp;dnia 12.04.2017&nbsp;roku. 
                        Wskaźnik informuje o&nbsp;wielkości zysku lub&nbsp;straty przypadającej na&nbsp;jednostkę wartości zaangażowanych w&nbsp;podmiocie 
                        aktywów, czyli wyznacza on&nbsp;ogólną zdolność aktywów podmiotu do&nbsp;generowania zysku. Informuje o&nbsp;efektywności gospodarowania 
                        powierzonymi środkami. Zgodnie z&nbsp;punktacją zawartą w&nbsp;Rozporządzeniu za&nbsp;optymalny wynik wskaźnika uznaje&nbsp;się wartość 
                        powyżej&nbsp;4%. Im&nbsp;wyższa jest wartość wskaźnika, tym korzystniejsza jest sytuacja finansowa podmiotu.
                        <br/><br/>

                        <span className='text-wskazniki text-bold'>Wskaźnik bieżącej płynności </span>
                        <br/>
                        Wskaźnik bieżącej płynności wyznaczono w&nbsp;oparciu o&nbsp;Rozporządzenie MZ&nbsp;z&nbsp;dnia 12.04.2017&nbsp;roku. 
                        Wskaźnik określa zdolność podmiotu do&nbsp;spłaty zobowiązań krótkoterminowych poprzez upłynnienie wszystkich środków obrotowych. 
                        Zgodnie z&nbsp;punktacją zawartą w&nbsp;Rozporządzeniu za&nbsp;optymalny wynik wskaźnika uznaje&nbsp;się wartości z&nbsp;przedziału&nbsp;1,5-3,0. 
                        Jeżeli poziom wskaźników płynności obniża&nbsp;się, to&nbsp;występuje ryzyko utraty przez podmiot zdolności do&nbsp;terminowego regulowania 
                        zobowiązań. W&nbsp;przypadku, gdy wskaźniki płynności są&nbsp;zbyt wysokie, może to&nbsp;świadczyć o&nbsp;nieefektywnym gospodarowaniu 
                        posiadanymi środkami obrotowymi.
                        <br/><br/>

                        <span className='text-wskazniki text-bold'>Wskaźnik szybkiej płynności</span>
                        <br/>
                        Wskaźnik szybkiej płynności wyznaczono w&nbsp;oparciu o&nbsp;Rozporządzenie MZ&nbsp;z&nbsp;dnia 12.04.2017&nbsp;roku. Wskaźnik określa zdolność 
                        podmiotu do&nbsp;spłacania zobowiązań krótkoterminowych najbardziej płynnymi aktywami, tj.&nbsp;krótkoterminowymi należnościami i&nbsp;aktywami 
                        finansowymi. Zgodnie z&nbsp;punktacją zawartą w&nbsp;Rozporządzeniu za&nbsp;optymalny wynik wskaźnika uznaje&nbsp;się wartości z&nbsp;przedziału 
                        1,00-2,50. Jeżeli poziom wskaźników płynności obniża&nbsp;się, to&nbsp;występuje ryzyko utraty przez podmiot zdolności do&nbsp;terminowego 
                        regulowania zobowiązań. W&nbsp;przypadku, gdy wskaźniki płynności są&nbsp;zbyt wysokie, może to&nbsp;świadczyć o&nbsp;nieefektywnym gospodarowaniu 
                        posiadanymi środkami obrotowymi.
                        <br/><br/>

                        <span className='text-wskazniki text-bold'>Wskaźnik rotacji należności</span>
                        <br/>
                        Wskaźnik rotacji należności (w&nbsp;dniach) wyznaczono w&nbsp;oparciu o&nbsp;Rozporządzenie MZ&nbsp;z&nbsp;dnia 12.04.2017&nbsp;roku. Wskaźnik określa 
                        długość cyklu oczekiwania podmiotu na&nbsp;uzyskanie należności za&nbsp;świadczone usługi. Im&nbsp;wyższy poziom wskaźnika, tym podmiot ma&nbsp;większe 
                        trudności ze&nbsp;ściągalnością swoich należności, co&nbsp;może obniżyć zdolność do&nbsp;terminowego regulowania zobowiązań. Zgodnie z&nbsp;punktacją 
                        zawartą w&nbsp;Rozporządzeniu za&nbsp;optymalny wynik uznaje&nbsp;się wartość wskaźnika poniżej 45&nbsp;dni.
                        <br/><br/>

                        <span className='text-wskazniki text-bold'>Wskaźnik rotacji zobowiązań</span>
                        <br/>
                        Wskaźnik rotacji zobowiązań (w&nbsp;dniach) wyznaczono w&nbsp;oparciu o&nbsp;Rozporządzenie MZ&nbsp;z&nbsp;dnia 12.04.2017&nbsp;roku. Wskaźnik określa okres, 
                        jaki jest potrzebny podmiotowi do&nbsp;spłacenia swoich zobowiązań krótkoterminowych. Zgodnie z&nbsp;punktacją zawartą w&nbsp;Rozporządzeniu za&nbsp;optymalny 
                        wynik uznaje&nbsp;się wartość wskaźnika do&nbsp;60 dni. Zbyt wysoka wartość wskaźnika może świadczyć o&nbsp;trudnościach podmiotu w&nbsp;regulowaniu swoich 
                        bieżących zobowiązań.
                        <br/><br/>

                        <span className='text-wskazniki text-bold'>Wskaźnik wypłacalności </span>
                        <br/>
                        Wskaźnik wypłacalności wyznaczono w&nbsp;oparciu o&nbsp;Rozporządzenie MZ&nbsp;z&nbsp;dnia 12.04.2017&nbsp;roku. Wskaźnik określa wielkość funduszy obcych 
                        przypadającą na&nbsp;jednostkę funduszu własnego. Zgodnie z&nbsp;punktacją zawartą w&nbsp;Rozporządzeniu za&nbsp;optymalny wynik wskaźnika uznaje&nbsp;się 
                        wartości z&nbsp;przedziału 0,00-0,50. Wysoka wartość wskaźnika wskazuje na&nbsp;możliwość utraty zdolności do&nbsp;regulowania przez podmiot zobowiązań 
                        (powyżej&nbsp;4,00).
                        <br/><br/>

                        <span className='text-wskazniki text-bold'>Wskaźnik zadłużenia aktywów </span>
                        <br/>
                        Wskaźnik zadłużenia aktywów&nbsp;(%) wyznaczono w&nbsp;oparciu o&nbsp;Rozporządzenie MZ&nbsp;z&nbsp;dnia 12.04.2017&nbsp;roku. Wskaźnik informuje o&nbsp;stopniu 
                        finansowania aktywów kapitałami obcymi. Zgodnie z&nbsp;punktacją zawartą w&nbsp;Rozporządzeniu za&nbsp;optymalną wartość wskaźnika uznaje&nbsp;się wielkość 
                        poniżej&nbsp;40%. Zbyt wysoka wartość wskaźnika podważa wiarygodność finansową podmiotu.
                        <br/><br/>

                        <span className='text-wskazniki text-bold'>Wskaźnik pokrycia obsługi długu </span>
                        <br/>
                        Wskaźnik pokrycia obsługi długu informuje, ile razy zysk brutto z&nbsp;działalności podmiotu wraz z&nbsp;odsetkami pokrywa roczne spłaty rat kapitałowych 
                        i&nbsp;odsetki, czyli obsługę kredytu. Wskaźnik powinien przyjmować wartość większą od&nbsp;1 (minimum 1,2). Wartość wskaźnika zależy od&nbsp;kondycji finansowej 
                        podmiotu.
                        <br/><br/>

                        <span className='text-wskazniki text-bold'>Wskaźnik pokrycia majątku trwałego kapitałem stałym</span>
                        <br/>
                        Wskaźnik pokrycia majątku trwałego kapitałem stałym informuje w&nbsp;jakim stopniu kapitał stały (zobowiązania długoterminowe + kapitał własny) pokrywa aktywa 
                        trwałe. Wartości wskaźnika powyżej&nbsp;1 świadczą o&nbsp;stabilności finansowej jednostki (utrzymanie równowagi finansowej). Wartości wskaźnika bliskie&nbsp;1 
                        oznaczają wysokie ryzyko utraty stabilności finansowej. Wartości wskaźnika poniżej&nbsp;1 świadczą o&nbsp;utracie stabilności finansowej; w&nbsp;takiej sytuacji 
                        aktywa trwałe finansowane są&nbsp;kapitałami obcymi krótkoterminowymi, co&nbsp;jest bardzo niebezpieczne (obowiązek spłaty zobowiązań krótkoterminowych może 
                        rodzić konieczność wyprzedawania majątku trwałego, a w&nbsp;rezultacie zmniejszenie skali działania).
                        <br/><br/>
                        
                        <span className='text-wskazniki text-bold'>Średni jednostkowy koszt świadczenia</span>
                        <br/>
                        Średni jednostkowy koszt świadczenia to&nbsp;iloraz kosztu całkowitego OPK i&nbsp;liczby zrealizowanych świadczeń w&nbsp;OPK w&nbsp;danym okresie.
                        <br/><br/>
                        
                        <span className='text-wskazniki text-bold'>Struktura kosztów OPK</span>
                        <br/>
                        Struktura kosztów OPK pokazuje udział&nbsp;% poszczególnych kategorii kosztów w&nbsp;koszcie całkowitym OPK w&nbsp;danym okresie. Kategorie kosztów: koszty 
                        bezpośrednie, koszty pośrednie działalności pomocniczej medycznej i&nbsp;niemedycznej, koszty procedur medycznych oraz koszty zarządu.
                        <br/><br/>
                        
                        <span className='text-wskazniki text-bold'>Analiza rentowności OPK</span>
                        <br/>
                        Analiza rentowności OPK to&nbsp;określenie stopnia zyskowności prowadzonej działalności (funkcjonowania OPK). Iloraz wyniku finansowego OPK i&nbsp;przychodów 
                        w&nbsp;danym okresie.
                        <br/><br/>
                        
                        <span className='text-wskazniki text-bold'>Pokrycie kosztów przychodami</span>
                        <br/>
                        Wskaźnik pokrycia kosztów przychodami&nbsp;(%) informuje w&nbsp;jakim stopniu przychody całkowite OPK pokrywają koszty całkowite OPK w&nbsp;danym okresie.
                        <br/><br/>
                        
                        <span className='text-wskazniki text-bold'>Średni jednostkowy rzeczywisty koszt osobodnia</span>
                        <br/>
                        Średni jednostkowy rzeczywisty koszt osobodnia ustala&nbsp;się jako iloraz kosztów całkowitych OPK w&nbsp;okresie i&nbsp;rzeczywistą liczbę wykonanych 
                        osobodni w&nbsp;OPK w&nbsp;analogicznym okresie.
                        <br/><br/>

                        <Button className="btn-round" color="wskazniki" onClick={() => {
                            window.focus();
                            window.scrollTo(0, 0);
                            displayFunction('main');
                        }} style={{float: "right", margin: "0px !important"}}> Powrót </Button>
                    </CardBody>
                </Card>
            </>}
        </div>
    )
}

const mapStateToProps = (state) => ({
    loadingMy: state.companyReducer.loadingMy,
    errorMy: state.companyReducer.errorMy,
    myCompany: state.companyReducer.myCompany,
});

export default connect(mapStateToProps, {getMyCompany})(IndicatorsPage)